//ref: https://velog.io/@ijinkyung/React-TypeScript-%ED%83%80%EC%9D%B4%EB%A8%B8-%EA%B5%AC%ED%98%84%ED%95%98%EA%B8%B0
import { useState, useEffect } from "react"

const useTimer = () => {
  const MINUTES_IN_MS = 3 * 60 * 1000
  const INTERVAL = 1000
  const [timeLeft, setTimeLeft] = useState<number>(MINUTES_IN_MS)
  const minutes = String(Math.floor((timeLeft / (1000 * 60)) % 60)).padStart(
    2,
    "0"
  )
  const seconds = String(Math.floor((timeLeft / 1000) % 60)).padStart(2, "0")

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - INTERVAL)
    }, INTERVAL)

    if (timeLeft <= 0) {
      clearInterval(timer)
      console.log("타이머가 종료되었습니다.")
    }

    return () => {
      clearInterval(timer)
    }
  }, [timeLeft])

  return { timeLeft, minutes, seconds }
}

export default useTimer
